import script from "./type_medical.vue?vue&type=script&setup=true&lang=js"
export * from "./type_medical.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__